import { toSentenceCase } from "./stringUtils";

export const WIZARD_CARD_HEADER = "Create Random Draw";

export const WIZARD_SETUP_HEADER = "Setup";

export const WIZARD_RESULTS_HEADER = "View your results";

export const WIZARD_REVIEW_HEADER = "Review";

export const WIZARD_TIMING_HEADER = "Timing";

export const WIZARD_ENTRIES_HEADER = "Entries";

export const WIZARD_PRIZES_HEADER = "Prizes";

export const WIZARD_PAYMENT_HEADER = "Payment";

export const WIZARD_SCHEDULED_HEADER = "Scheduled";

const STEPPER_LABELS: Record<string, string> = {
  [toSentenceCase("SETUP")]: "Setup",
  [toSentenceCase("ENTRY METHOD")]: "Entries",
  [toSentenceCase("ENTRY CONFIGURATION")]: "Entries",
  [toSentenceCase("PRIZES")]: "Prizes",
  [toSentenceCase("SCHEDULING")]: "Timing",
  [toSentenceCase("REVIEW")]: "Review",
  [toSentenceCase("EXECUTE")]: "Draw",
  [toSentenceCase("SCHEDULED")]: "Scheduled",
  [toSentenceCase("PAYMENT")]: "Payment",
  [toSentenceCase("RESULTS")]: "Results",
};

export const getStepperLabel = (stepName: string): string =>
  STEPPER_LABELS[stepName] ?? stepName;

const RESULTS_HEADER_STEPS = new Set([
  toSentenceCase("EXECUTE"),
  toSentenceCase("RESULTS"),
]);

const ENTRIES_HEADER_STEPS = new Set([
  toSentenceCase("ENTRY METHOD"),
  toSentenceCase("ENTRY CONFIGURATION"),
]);

export const getWizardCardHeader = (stepName: string): string => {
  if (stepName === toSentenceCase("SETUP")) return WIZARD_SETUP_HEADER;
  if (RESULTS_HEADER_STEPS.has(stepName)) return WIZARD_RESULTS_HEADER;
  if (ENTRIES_HEADER_STEPS.has(stepName)) return WIZARD_ENTRIES_HEADER;
  if (stepName === toSentenceCase("REVIEW")) return WIZARD_REVIEW_HEADER;
  if (stepName === toSentenceCase("SCHEDULING")) return WIZARD_TIMING_HEADER;
  if (stepName === toSentenceCase("PRIZES")) return WIZARD_PRIZES_HEADER;
  if (stepName === toSentenceCase("PAYMENT")) return WIZARD_PAYMENT_HEADER;
  if (stepName === toSentenceCase("SCHEDULED")) return WIZARD_SCHEDULED_HEADER;
  return WIZARD_CARD_HEADER;
};

export interface StepperItem {
  label: string;
  firstStep: number;
  lastStep: number;
}

export const buildStepperItems = (stepNames: string[]): StepperItem[] => {
  const items: StepperItem[] = [];
  stepNames.forEach((name, index) => {
    const label = getStepperLabel(name);
    const previous = items[items.length - 1];
    if (previous && previous.label === label) {
      previous.lastStep = index;
    } else {
      items.push({ label, firstStep: index, lastStep: index });
    }
  });
  return items;
};
